import { render, staticRenderFns } from "./AppDetailsPallete.vue?vue&type=template&id=02e48521&scoped=true&"
import script from "./AppDetailsPallete.vue?vue&type=script&lang=js&"
export * from "./AppDetailsPallete.vue?vue&type=script&lang=js&"
import style0 from "./AppDetailsPallete.vue?vue&type=style&index=0&id=02e48521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e48521",
  null
  
)

export default component.exports